
import React from 'react';

const Expertise = ({ skills }) => {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '1.5rem' }}>
            {skills.map((skill, index) => (
                <div
                    key={index}
                    className="hover-scale"
                    style={{
                        backgroundColor: 'var(--color-bg-secondary)',
                        padding: '1.5rem',
                        borderRadius: '16px',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '1rem'
                    }}
                >
                    <div style={{ fontSize: '2.5rem', color: 'var(--color-text-primary)' }}>
                        {skill.icon}
                    </div>
                    <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>{skill.name}</span>
                </div>
            ))}
        </div>
    );
};

export default Expertise;
